import Layout from "../../layouts/Layout";
import axios from "axios";
import { useMemo, useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle } from "react-leaflet";
import { useTranslation } from "react-i18next";
import L from "leaflet";
import { NavLink } from "react-router-dom";

const MapView = () => {
    const markerRef = useRef();
    const position = ([38.17058503265006, 23.965004389531703]);
    const markers = [
        { 
            geocode: [38.17058503265006, 23.965004389531703], // original position
            title: 'Completed', 
            start: '2025-02-09T10:00:00', 
            end: '2025-02-09T12:00:00',
            description: 'This is a completed event.', 
            status: 'completed', 
            borderColor: 'border-cal-dblue',
            backgroundColor: 'bg-cal-lblue',
        }
    ];

    // functions
    const getCustomIcon = (status) => {
        let color = '';
        
        switch (status) {
            case 'completed':
                color = '#1BC5BD';
                break;
            case 'pending':
                color = '#FFA800';
                break;
            case 'cancelled':
                color = '#F64E60';
                break;
            default:
                color = '#0000FF';
        }

        const iconSvg = `
        <svg width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.27427 12.8429L7.77441 23.7218C7.87654 23.8929 8.06059 23.9985 8.25988 24H8.26484C8.46223 24 8.6459 23.8979 8.75031 23.7302L15.5164 12.8513C15.5332 12.8242 15.5477 12.796 15.5591 12.7675C16.3681 11.4463 16.7949 9.93732 16.7949 8.39669C16.7949 3.76679 13.0273 0 8.3963 0C3.76679 0 0 3.76679 0 8.39669C0 9.9377 0.427169 11.4471 1.23654 12.7686C1.24721 12.7941 1.25979 12.8189 1.27427 12.8429Z" fill="${color}"/>
            <path d="M4 6.87988V7.19988C4 8.09588 4.704 8.79988 5.6 8.79988C6.112 8.79988 6.592 8.54388 6.88 8.15988C7.168 8.54388 7.648 8.79988 8.16 8.79988C8.672 8.79988 9.152 8.54388 9.44 8.15988C9.728 8.54388 10.208 8.79988 10.72 8.79988C11.616 8.79988 12.32 8.09588 12.32 7.19988V6.87988H4Z" fill="white"/>
            <path d="M11.3281 4.192C11.2961 4.064 11.1681 4 11.0401 4H5.28007C5.15207 4 5.02407 4.064 4.99207 4.192L4.09607 6.24H12.1921L11.3281 4.192Z" fill="white"/>
            <path d="M4.31995 9.02393V11.6799C4.31995 11.8719 4.44795 11.9999 4.63995 11.9999H6.87995V9.02393C6.49595 9.31193 6.07995 9.43993 5.59995 9.43993C5.11995 9.43993 4.67195 9.27993 4.31995 9.02393ZM6.01595 9.85593C6.04795 9.82393 6.07995 9.79193 6.11195 9.79193C6.23995 9.72793 6.36795 9.75993 6.46395 9.85593C6.49595 9.88793 6.52795 9.91993 6.52795 9.95193C6.52795 9.98393 6.55995 10.0479 6.55995 10.0799C6.55995 10.1119 6.55995 10.1759 6.52795 10.2079C6.49595 10.2399 6.49595 10.2719 6.46395 10.3039C6.43195 10.3359 6.39995 10.3679 6.36795 10.3679C6.33595 10.3679 6.27195 10.3999 6.23995 10.3999C6.14395 10.3999 6.07995 10.3679 6.01595 10.3039C5.98395 10.2719 5.95195 10.2399 5.95195 10.2079C5.91995 10.1759 5.91995 10.1119 5.91995 10.0799C5.91995 9.98393 5.95195 9.91993 6.01595 9.85593Z" fill="white"/>
            <path d="M9.44002 9.02393C9.05602 9.27993 8.64002 9.43993 8.16002 9.43993C7.93602 9.43993 7.71202 9.40793 7.52002 9.34393V11.9999H11.68C11.872 11.9999 12 11.8719 12 11.6799V9.02393C11.648 9.27993 11.2 9.43993 10.72 9.43993C10.24 9.43993 9.82402 9.31193 9.44002 9.02393Z" fill="white"/>
        </svg>`;

        return new L.Icon({
            iconUrl: "data:image/svg+xml," + encodeURIComponent(iconSvg),
            iconSize: [17, 24],
            iconAnchor: [8, 24],
            popupAnchor: [0, -24],
        });
    };

    return (
        <div className="relative">
            <div className="absolute right-8 top-8 z-50">
                <NavLink to={`/profiles/appointment/${8337}`}>
                    <div className="bg-white flex items-center p-3 rounded-lg">
                        <img src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                    </div>
                </NavLink>
            </div>
            <Layout>
                <MapContainer center={position} zoom={13} style={{ height: "100vh", width: "100%" }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {markers.length > 0 ? markers.map((marker, index) => (
                        <Marker 
                            key={index} 
                            position={marker.geocode} 
                            ref={markerRef} 
                            icon={getCustomIcon(marker.status)}
                        >
                        </Marker>
                    )) : null}
                </MapContainer>
            </Layout>
        </div>
    )
}

export default MapView;